const cookies = () => {
  const cookiesContainer = document.querySelector('.js-cookies');
  if (cookiesContainer) {
    const cookiesAccept = localStorage.getItem('cookiesAccept');
    if (cookiesAccept === 'true') {
      return;
    }
    cookiesContainer.classList.remove('u-hidden');
    const cookiesButton = document.querySelector('.js-cookies-button');
    if (cookiesButton) {
      cookiesButton.addEventListener('click', () => {
        localStorage.setItem('cookiesAccept', 'true');
        cookiesContainer.classList.add('u-hidden');
      });
    }
  }
};

export default cookies;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/cookies.js